const CloseButton = {
    baseStyle: {
        borderRadius: '50%',
        fontWeight: 900,
    },
    defaultProps: {},
    variants: {},
};
export default CloseButton;
